module.exports = __webpack_public_path__ + "img/desktop-neck-18_50x698.7d3a0439.png";